import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AuxiliaryCompressor from "../components/auxiliary-Compressor";
import SisLoader from "../../../../widgets/loader";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

const AuxilaryCompressorLog = () => {
  const { eng_log_basic_id } = useParams();
  const [loader, set_loader] = useState(false);
  const [compressor_Data, set_Compressor_Data] = useState([]);

  const GET_SHIP_COMPRESSOR_LISTS = async (ship_Id) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_Id);
      post(ApiURL.list_ship_compressor_details_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_loader(false);
          set_Compressor_Data(res?.response_data);
        }
      });
    } catch (error) {
      set_loader(false);
    }
  };

  useEffect(() => {
    const ship_id = JSON.parse(localStorage.getItem("ship_id"));
    GET_SHIP_COMPRESSOR_LISTS(ship_id);
  }, []);

  return (
    <>
      <div className="white-container">
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {compressor_Data?.length > 0 ? (
              <>
                {compressor_Data?.map((_items) => (
                  <>
                    <AuxiliaryCompressor eng_log_basic_id={eng_log_basic_id} _items={_items} />
                  </>
                ))}
              </>
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AuxilaryCompressorLog;
